'use client'
import { ArrowDark, ArrowLight } from '@/assets/ icons'
import stake from '@/assets/images/stake.svg'
import { GET_ODD_WIDGET } from '@/graphql/globalwidget/rankings.query'
import usePolling from '@/shared/hooks/usePolling'
import useTimer from '@/shared/hooks/useTimer'
import { useAds } from '@/shared/revive-ads/ads-context'
import { convertDt24hFormat, getImgURL } from '@/shared/utils'
import { useLazyQuery } from '@apollo/client'
import React, { useEffect, useRef, useState } from 'react'
import CustomLink from '../customLink'
import MyImage from '../myImage'

const StakeWidget = () => {
  const { isAdsActive } = useAds()
  const [currentSlide, setCurrentSlide] = useState(0)
  const [touchStart, setTouchStart] = useState(0)
  const [touchEnd, setTouchEnd] = useState(0)
  const [getOddWIdget, { data: widgetData }] = useLazyQuery(GET_ODD_WIDGET, {
    fetchPolicy: 'network-only'
  })
  const totalSlides = widgetData?.getOddsWidget?.length || 0
  const sliderRef = useRef<HTMLDivElement>(null)

  // Minimum swipe distance
  const minSwipeDistance = 50

  usePolling(getOddWIdget, { interval: 10000 })

  useEffect(() => {
    getOddWIdget()
  }, [])

  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX)
  }

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX)
  }

  const handlePrevSlide = () => {
    setCurrentSlide(prev => (prev > 0 ? prev - 1 : totalSlides - 1))
  }

  const handleNextSlide = () => {
    setCurrentSlide(prev => (prev < totalSlides - 1 ? prev + 1 : 0))
  }

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return

    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > minSwipeDistance
    const isRightSwipe = distance < -minSwipeDistance

    if (isLeftSwipe) {
      setCurrentSlide(prev => (prev < totalSlides - 1 ? prev + 1 : 0))
    } else if (isRightSwipe) {
      setCurrentSlide(prev => (prev > 0 ? prev - 1 : totalSlides - 1))
    }

    setTouchStart(0)
    setTouchEnd(0)
  }

  // const statusColor: Record<string, string> = {
  //   live: 'text-danger',
  //   scheduled: 'text-ScheduledBG',
  //   completed: 'text-primary-500',
  //   cancelled: 'text-danger'
  // }

  const Timer = ({ date }: { date: any }) => {
    const { timer } = useTimer(date)
    if (timer.hours !== 0 && timer.min !== 0) {
      return (
        <div className='text-textOffWhite text-sm md:text-lg font-bold'>
          {timer.days} : {timer.hours} : {timer.min}
        </div>
      )
    } else {
      return null
    }
  }

  if (widgetData?.getOddsWidget?.length === 0) return null

  return (
    <div className="relative">
      <a
        className="absolute inset-0 w-full h-full z-10"
        target="_blank"
        href="https://vip.stakeclick.com/go/e64a8b1d-eafd-4e2b-80dc-a6cf85d260ef"
        rel="noreferrer"
      />
      <div
        className=' bg-headerFooter border border-tabBorder w-full max-w-md mx-auto rounded-xl overflow-hidden mt-2 md:mt-2'
        ref={sliderRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Header */}
        <div className='text-center bg-[#F5F8F1] rounded-t-xl dark:bg-stakeGradient  py-3.5 px-5'>
          <h2 className='text-base md:text-xl font-bold mb-0 dark:text-ScheduledBG text-black'>
            Who will Win?
          </h2>
        </div>

        {widgetData?.getOddsWidget?.map((m: any, i: number) => {
          if (currentSlide === i) {
            return (
              <div
                key={i}
                className='pt-4 px-6 flex-col flex justify-center pb-6'
              >
                <CustomLink href={`/${m?.oMatch?.oSeo?.sSlug}`}>
                  <p className='text-sm text-TextScoredCompplete mb-4 text-center'>
                    {m?.oMatch?.oSeries?.sSrtTitle}
                  </p>
                  <div className='flex w-full items-center justify-between gap-3 flex-shrink-0'>
                    <div className='flex-shrink-0'>
                      <MyImage
                        src={
                          m?.oMatch?.oTeamScoreA?.oTeam?.oImg?.sUrl
                            ? getImgURL(
                                m?.oMatch?.oTeamScoreA?.oTeam?.oImg?.sUrl
                              )
                            : ''
                        }
                        height={54}
                        width={54}
                        alt='Team A Flag'
                        className='rounded-full object-cover w-[54px] h-[54px]'
                      />
                    </div>
                    <div className='text-center w-full'>
                      {/* <span className={`flex justify-center items-center capitalize ${statusColor[m?.oMatch?.sStatusStr]}`}>
                        {m?.oMatch?.sStatusStr === 'live' ? (
                          <>
                            <span className='h-2.5 w-2.5 block rounded-full animate-pulse bg-danger mr-1' />
                            {m?.oMatch?.sStatusStr}
                          </>
                        ) : (
                          m?.oMatch?.sStatusStr
                        )}
                      </span> */}
                      {m?.oMatch?.sStatusStr === 'scheduled' && (
                        <div className=''>
                          <Timer date={m?.oMatch?.dStartDate} />
                          <span className='text-xs text-TextScoredCompplete'>
                            {convertDt24hFormat(m?.oMatch?.dStartDate)}
                          </span>
                        </div>
                      )}
                      {m?.oMatch?.sStatusStr === 'live' && (
                        <span
                          className={`flex justify-center items-center capitalize text-danger`}
                        >
                          <span className='h-2.5 w-2.5 block rounded-full animate-pulse bg-danger mr-1 mb-0.5' />
                          live
                        </span>
                      )}
                    </div>
                    <div className=' flex-shrink-0'>
                      <MyImage
                        src={
                          m?.oMatch?.oTeamScoreB?.oTeam?.oImg?.sUrl
                            ? getImgURL(
                                m?.oMatch?.oTeamScoreB?.oTeam?.oImg?.sUrl
                              )
                            : ''
                        }
                        height={80}
                        width={80}
                        alt='Team B Flag'
                        className='rounded-full object-cover w-[54px] h-[54px]'
                      />
                    </div>
                  </div>

                  <div className=' flex items-center justify-between gap-4 mt-6'>
                    <div className='py-1.5 px-2 dark:bg-[#033D62] bg-[#F8F8F8] border dark:border-[#22292F] border-[#EFEFEF]  rounded-full items-center flex gap-7'>
                      <MyImage
                        src={
                          m?.oMatch?.oTeamScoreA?.oTeam?.oImg?.sUrl
                            ? getImgURL(
                                m?.oMatch?.oTeamScoreA?.oTeam?.oImg?.sUrl
                              )
                            : ''
                        }
                        height={24}
                        width={24}
                        alt='Team A Flag'
                        className='rounded-full flex-shrink-0 w-6 h-6 object-cover'
                      />
                      <span className='text-base font-bold text-t-origin'>
                        {
                          m?.odds?.outcomes?.find(
                            (d: any) =>
                              d?.iTeamId === m?.oMatch?.oTeamScoreA?.oTeam?._id
                          )?.odds
                        }
                      </span>
                    </div>
                    <div className='py-1.5 px-2 dark:bg-[#033D62] bg-[#F8F8F8] border dark:border-[#22292F] border-[#EFEFEF] rounded-full items-center flex gap-7'>
                      <MyImage
                        src={
                          m?.oMatch?.oTeamScoreB?.oTeam?.oImg?.sUrl
                            ? getImgURL(
                                m?.oMatch?.oTeamScoreB?.oTeam?.oImg?.sUrl
                              )
                            : ''
                        }
                        height={25}
                        width={25}
                        alt='Team B Flag'
                        className='rounded-full flex-shrink-0 w-6 h-6 object-cover'
                      />
                      <span className='text-base font-bold text-t-origin'>
                        {
                          m?.odds?.outcomes?.find(
                            (d: any) =>
                              d?.iTeamId === m?.oMatch?.oTeamScoreB?.oTeam?._id
                          )?.odds
                        }
                      </span>
                    </div>
                  </div>
                </CustomLink>
              </div>
            )
          }
        })}

        <div className=' pb-3.5'>
          {isAdsActive ? (
            <div className='flex w-full gap-4 justify-between items-center pb-2.5 px-6'>
              <button
                onClick={handlePrevSlide}
                className="z-20 size-5 flex justify-center items-center rounded-full transition-colors rotate-180"
              >
                <span className=' dark:block hidden'>
                  <ArrowDark />
                </span>
                <span className='dark:hidden block'>
                  <ArrowLight />
                </span>
              </button>
              <div className='dark:bg-stakeGradient bg-[#F5F8F1] p-3 flex gap-7 items-center rounded-xl'>
                <p className='text-xs font-normal dark:text-[#D9D9D9] text-black text-textDselected'>
                  Powered By
                </p>
                <MyImage
                  src={stake}
                  className=' dark:brightness-[1] brightness-0'
                  height={27}
                  width={55}
                />
              </div>
              <button
                onClick={handleNextSlide}
                className="z-20 rounded-full  size-5 flex justify-center items-center transition-colors"
              >
                <span className='dark:block hidden'>
                  <ArrowDark />
                </span>
                <span className='dark:hidden block'>
                  <ArrowLight />
                </span>
              </button>
            </div>
          ) : null}
          <div className="z-20 relative flex justify-center mt-2 space-x-2">
            {[...Array(totalSlides)].map((_, index) => (
              <div
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`size-2 rounded-full hover:size-2 cursor-pointer ${
                  index === currentSlide
                    ? 'bg-stakeWidgetBtn'
                    : 'bg-[#EFEFEF] dark:bg-[#2F363C]'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default StakeWidget
